import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { debugLog, FLUTTER_POST_MESSAGE_TYPES, FLUTTER_STATUS_TYPES } from 'src/app/core/constants/General-constants';
import { Payment, Transaction } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-wallet-dialog',
    templateUrl: 'wallet-dialog.component.html',
})
export class WalletDialogComponent implements OnInit {
    iframeHeight: string = '100%';
    transaction: Transaction;

    constructor(
        private readonly router: Router,
        private readonly tokenServiceService: TokenServiceService,
        private readonly authService: AuthService,
        public dialogRef: MatDialogRef<WalletDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { info: Payment, url: string, changeMethod: () => void }
    ) { }

    async ngOnInit() {
        this.transaction = this.tokenServiceService.getAndDecodeToken();

        window.addEventListener(
            'message',
            async (event) => {
                debugLog({ event, info: this.data })

                if (event.origin !== environment.urlWallet) return;

                let data = event.data;

                if (typeof event.data === 'string') data = JSON.parse(event.data);

                switch (data.type) {
                    case FLUTTER_POST_MESSAGE_TYPES.STATUS_CHANGE:
                        if (FLUTTER_STATUS_TYPES.APPROVED) {
                            this.authService.setSummary({ STATUS: FLUTTER_STATUS_TYPES.APPROVED });

                            this.dialogRef.close();

                            await this.router.navigate(['checkout/alertBE']);
                        }

                        break;
                    default:
                        break;
                }
            },
        );

    }
}